import type { ReactNode, FC } from 'react';
import c from 'classnames';
import s from './PageErrorMessage.scss';

export interface Props {
  className?: string;
  children: ReactNode;
}

const PageErrorMessage: FC<Props> = ({ className, children }) => {
  return <div className={c(s['root'], className)}>{children}</div>;
};
PageErrorMessage.displayName = 'PageErrorMessage';

export default PageErrorMessage;
